<template>
  <div>
    <!-- 眼底 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>眼底
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="眼底">
          <el-radio-group v-model="formData.eyeground" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <div class="flex-center">
            <el-select v-model="formData.eyegroundException"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in eyegroundExceptionDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'EYEGROUND_EXCEPTION_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 皮肤 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>皮肤
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="皮肤">
          <el-radio-group v-model="formData.skin" size="small">
            <el-radio-button
              v-for="item in skinDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他">
          <div class="flex-center">
            <el-select v-model="formData.skinOthers"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in skinOthersDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'SKIN_OTHERS_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 巩膜 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>巩膜
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="巩膜">
          <el-radio-group v-model="formData.sclera" size="small">
            <el-radio-button
              v-for="item in scleraDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他">
          <div class="flex-center">
            <el-select v-model="formData.scleraOthers"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in scleraOthersDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'SCLERA_OTHERS_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 淋巴结 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>淋巴结
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="淋巴结">
          <el-radio-group v-model="formData.lymphNode" size="small">
            <el-radio-button
              v-for="item in lymphNodeDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他">
          <div class="flex-center">
            <el-select v-model="formData.lymphNodeOthers"  size="mini" style="width: 100%;">
              <el-option
                  v-for="option in lymphNodeOthersDict"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value">
                </el-option>
            </el-select>
            <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'EYEGROUND_EXCEPTION_DICT')"></el-button>
          </div>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 肺 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>肺
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="桶状胸">
          <el-radio-group v-model="formData.lungBarrelChest" size="small">
            <el-radio-button label="0">否</el-radio-button>
            <el-radio-button label="1">是</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="呼吸音">
          <el-radio-group v-model="formData.lungBreathSound" size="small">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.lungBreathSoundExcep" placeholder="请输入异常描述"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="罗音">
          <el-radio-group v-model="formData.lungRhonchus" size="small">
            <el-radio-button
              v-for="item in raleDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他">
          <el-input v-model="formData.lungRhonchusException" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 心脏 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>心脏
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="心率">
          <el-input v-model="formData.heartRate" placeholder="请输入心率" >
              <template slot="append">次/分钟</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="心律">
          <el-radio-group v-model="formData.cardiacRhythm" size="small">
             <el-radio-button
               v-for="item in rhythmHeartDict"
               :key="item.value"
               :label="item.value">
               {{ item.label }}
             </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="杂音">
          <el-radio-group v-model="formData.cardiacSouffle" size="small">
            <el-radio-button label="0">无</el-radio-button>
            <el-radio-button label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.cardiacSouffleOthers" placeholder="请输入异常描述"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 腹部 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>腹部
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="压痛">
          <el-radio-group v-model="formData.abdoPressPain" size="small">
            <el-radio-button label="0">无</el-radio-button>
            <el-radio-button label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.abdoPressPainOth" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="包块">
          <el-radio-group v-model="formData.abdoMasses" size="small">
            <el-radio-button label="0">无</el-radio-button>
            <el-radio-button label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.abdoMassesOthers" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="肝大">
          <el-radio-group v-model="formData.abdoHepatomegaly" size="small">
            <el-radio-button label="0">无</el-radio-button>
            <el-radio-button label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.abdoHepatomegalyOth" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="脾大">
          <el-radio-group v-model="formData.abdoSplenomegaly" size="small">
            <el-radio-button label="0">无</el-radio-button>
            <el-radio-button label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.abdoSplenomegalyOth" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="移动性浊音">
          <el-radio-group v-model="formData.abdoShiftingDull" size="small">
            <el-radio-button label="0">无</el-radio-button>
            <el-radio-button label="1">有</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.abdoShiftingDullOth" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 下肢水肿 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>下肢水肿
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="24">
        <el-form-item label="下肢水肿">
          <el-radio-group v-model="formData.immersionFoot" size="small">
            <el-radio-button
              v-for="item in lowerEdemaDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 足背动脉搏动 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>足背动脉搏动
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="24">
        <el-form-item label="足背动脉搏动">
          <el-radio-group v-model="formData.dorsumOfFootArteriopalmus" size="small">
            <el-radio-button
              v-for="item in footPulsesDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 肛门指诊 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>肛门指诊
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="肛门指诊">
          <el-radio-group v-model="formData.fundamentFingerp" size="small">
            <el-radio-button
              v-for="item in anusDreDict"
              :key="item.value"
              :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他">
          <el-input v-model="formData.fundamentFingerpOth" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 乳腺 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>乳腺
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="24">
        <el-form-item label="乳腺">
          <el-checkbox  v-model="formData.breastNotTroubleFind" :true-label="'1'" :false-label="'0'" size="small">未及异常</el-checkbox>
          <el-checkbox  v-model="formData.breastMastectomy" :true-label="'1'" :false-label="'0'" size="small">乳房切除</el-checkbox>
          <el-checkbox  v-model="formData.breastAbnormalLactation" :true-label="'1'" :false-label="'0'" size="small">异常泌乳</el-checkbox>
          <el-checkbox  v-model="formData.breastMasses" :true-label="'1'" :false-label="'0'" size="small">乳腺包块</el-checkbox>
          <el-checkbox  v-model="formData.breastOthers" :true-label="'1'" :false-label="'0'" size="small">其他</el-checkbox>
          <el-input v-model="formData.breastOthersStr" placeholder="请输入其他描述" style="width: 300px; margin-left: 10px;"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 妇科 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>妇科
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="10">
        <el-form-item label="外阴">
          <el-radio-group v-model="formData.vulva" size="small">
            <el-radio-button label="1">未见异常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.vulvaException" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="阴道">
          <el-radio-group v-model="formData.vagina" size="small">
            <el-radio-button label="1">未见异常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.vaginaException" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="宫颈">
          <el-radio-group v-model="formData.cervix" size="small">
            <el-radio-button label="1">未见异常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.cervixException" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="宫体">
          <el-radio-group v-model="formData.corpus" size="small">
            <el-radio-button label="1">未见异常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.corpusException" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24" style="margin-left: 40px; margin-top: 15px;">
      <el-col :span="10">
        <el-form-item label="附件">
          <el-radio-group v-model="formData.attachment" size="small">
            <el-radio-button label="1">未见异常</el-radio-button>
            <el-radio-button label="2">异常</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="异常">
          <el-input v-model="formData.attachmentException" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- 其他 -->
    <div class="section-title">
      <i class="el-icon-menu" style="margin-right: 10px;"></i>其他
      <el-divider></el-divider>
    </div>
    <el-row :gutter="24" style="margin-left: 40px;">
      <el-col :span="24">
        <el-form-item label="其他">
          <el-input v-model="formData.physicalExaminationOth" placeholder="请输入"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PhysicalExam',
  props: {
    formData: {
      type: Object,
      required: true
    },
    skinDict: {
      type: Array,
      default: () => []
    },
    skinOthersDict: {
      type: Array,
      default: () => []
    },
    scleraDict: {
      type: Array,
      default: () => []
    },
    scleraOthersDict: {
      type: Array,
      default: () => []
    },
    lymphNodeDict: {
      type: Array,
      default: () => []
    },
    raleDict: {
      type: Array,
      default: () => []
    },
    rhythmHeartDict: {
      type: Array,
      default: () => []
    },
    lowerEdemaDict: {
      type: Array,
      default: () => []
    },
    footPulsesDict: {
      type: Array,
      default: () => []
    },
    anusDreDict: {
      type: Array,
      default: () => []
    },
    eyegroundExceptionDict: {
      type: Array,
      default: () => []
    },
    lymphNodeOthersDict: {
      type: Array,
      default: () => []
    },
  },
  computed: {

  }
}
</script>

<style scoped>
.section-title {
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 15px;
  color: #000;
}

.flex-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/medical-physical.vue